import { render, staticRenderFns } from "./Dockets.vue?vue&type=template&id=034ad538&"
import script from "./Dockets.vue?vue&type=script&lang=js&"
export * from "./Dockets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports